<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerAreas">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(area)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { AreaService } from "../../../services/AreaService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "AreaPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      area: null,
      areaService: new AreaService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerAreas() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.area) {
        return {
          title: this.area.value,
          id: this.ids[0],
          status: this.getStatus(this.area.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.area) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.area.code,
            },
          ],
          [
            {
              title: this.$t("areaValue"),
              text: this.area.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.area) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.area.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.area.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.area.createdAt) +
                " " +
                getAMorPM(this.area.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.area.lastUpdated) +
                " " +
                getAMorPM(this.area.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.area)
        : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getArea();
      } catch (e) {
        this.hasError = true;
      }
    },
    getArea() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.areaService.get(this.ids[0]).then((res) => {
          this.area = res.data;
          this.loading = false;
        });
      }
      this.area = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.area);
    },
    deletePanel() {
      this.$emit("delete", this.area);
    },
    showHistoryPanel() {
      this.$emit("history", this.area);
    },
  },
};
</script>

<style scoped></style>
